<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import KanbanAPI from 'dashboard/api/kanban';
import WinDealModal from './WinDealModal.vue';
import LoseDealModal from './LoseDealModal.vue';
import { getDealTotalValue } from './dealValue';

// Fechamento (ganho/perda) aberto a partir de qualquer seletor de etapa da
// conversa: mesmos endpoints e campos do ResolveDealPromptModal.
const props = defineProps({
  show: { type: Boolean, default: false },
  kind: { type: String, default: null },
  conversation: { type: Object, default: () => ({}) },
  mapping: { type: Object, default: null },
});
const emit = defineEmits(['close', 'closed']);

const { t } = useI18n();
const isSubmitting = ref(false);

const currentValue = computed(() =>
  getDealTotalValue(props.conversation, {
    mapping: props.mapping,
    funnelId: props.mapping?.funnel_id,
  })
);

const confirmWin = async data => {
  isSubmitting.value = true;
  try {
    await KanbanAPI.markDealAsWon(
      props.mapping.funnel_id,
      props.conversation.id,
      {
        final_value: data.finalValue,
        close_date: data.closeDate,
        notes: data.notes,
        won_reason: data.wonReason,
        won_reason_id: data.wonReasonId,
      }
    );
    useAlert(t('KANBAN.DEAL.WIN.SUCCESS'));
    emit('closed');
  } catch {
    useAlert(t('KANBAN.DEAL.WIN.ERROR'));
  } finally {
    isSubmitting.value = false;
    emit('close');
  }
};

const confirmLose = async data => {
  isSubmitting.value = true;
  try {
    await KanbanAPI.markDealAsLost(
      props.mapping.funnel_id,
      props.conversation.id,
      {
        reason: data.reason,
        reason_id: data.reasonId,
        notes: data.notes,
      }
    );
    useAlert(t('KANBAN.DEAL.LOSE.SUCCESS'));
    emit('closed');
  } catch {
    useAlert(t('KANBAN.DEAL.LOSE.ERROR'));
  } finally {
    isSubmitting.value = false;
    emit('close');
  }
};
</script>

<template>
  <WinDealModal
    v-if="kind === 'won'"
    :show="show"
    :conversation="conversation"
    :current-value="currentValue"
    :is-submitting="isSubmitting"
    @close="emit('close')"
    @confirm="confirmWin"
  />
  <LoseDealModal
    v-else-if="kind === 'lost'"
    :show="show"
    :conversation="conversation"
    @close="emit('close')"
    @confirm="confirmLose"
  />
</template>
